import { render, staticRenderFns } from "./CollectionsViewer.vue?vue&type=template&id=c46e2d3e&scoped=true&"
import script from "./CollectionsViewer.vue?vue&type=script&lang=js&"
export * from "./CollectionsViewer.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsViewer.vue?vue&type=style&index=0&id=c46e2d3e&lang=stylus&scoped=true&"
import style1 from "./CollectionsViewer.vue?vue&type=style&index=1&id=c46e2d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e2d3e",
  null
  
)

export default component.exports